import { render } from "./FormCardHeader.vue?vue&type=template&id=158d9d5c&lang=pug"
import script from "./FormCardHeader.vue?vue&type=script&lang=js"
export * from "./FormCardHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/quasar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QItem,QItemSection,QBtn,QTooltip,QSeparator});
